import React, { useEffect, useState } from 'react';

import * as Hooks from '../../hooks';
import { useAuthSelector } from '../../services/selectors/authSelector';
import { useAllSelector } from '../../services/selectors/allSelector';
import { clearData, missedRx3x4xRemovingPageNumber, fetchEmergencyPreparedRx } from '../../services/slices/dispense/missedRx3x4x';
import { ErrorMessages } from '../../components/error/errorMessages';
import * as Loading from '../../components/common/loader';

const EmergenciesTab = () => {

    const dispatch = Hooks.useCustomDispatch();
    const { pharmacyId } = useAuthSelector();
    const { missedRx3x4xResponse } = useAllSelector();

    const [loading, setLoading] = useState(false);
    const [apiCallMade, setApiCallMade] = useState(false);

    useEffect(() => {
        if (pharmacyId) {
            setLoading(true);
            if (!apiCallMade) {
                dispatch(clearData());
                dispatch(missedRx3x4xRemovingPageNumber());
                dispatch(fetchEmergencyPreparedRx({
                    pharmacy_id: pharmacyId,
                    setLoading: setLoading,
                }));
                setApiCallMade(true);
            }
        }
        return () => { };
    }, [pharmacyId]);

    const items = missedRx3x4xResponse?.emergenciesData || [];
    const isLoading = missedRx3x4xResponse?.emergenciesLoading && loading;
    const hasError = missedRx3x4xResponse?.emergenciesError !== null;

    return (
        <div className="missed-rx-list">
            {isLoading ? (
                <div className='flex justify-center h-96'>
                    <Loading.LoadingView />
                </div>
            ) : hasError ? (
                <div className='flex justify-center pb-4 mb-4'>
                    <ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
                </div>
            ) : (items.length === 0 && !missedRx3x4xResponse?.emergenciesLoading) ? (
                <p className='flex  pb-4 pt-3 h-96 text-gray-500'>No data available.</p>
            ) : (
                items.map((item, index) => (
                    <div key={(item.patient_id || index)} className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`emergencyCard-${index}`}>
                        <div className="flex">
                            <div className="flex items-center gap-2">
                                <h2 className="text-lg font-medium uppercase">
                                    {item.patient_name}
                                </h2>
                            </div>
                        </div>

                        <p className="text-xs text-gray-400 my-1 break-all" style={{ fontSize: '10px' }}>
                            PHN: {item.phn}
                        </p>

                        <div className="mt-2 mb-2 break-all">
                            {item.preparations?.map((prep, pIdx) => (
                                <div key={`${prep.rx_number || pIdx}`} className={`p-2 rounded-md ${pIdx > 0 ? 'mt-2' : ''}`} style={{ backgroundColor: '#f8f9fa', border: '1px solid lightgray' }}>
                                    <div className='flex gap-2 items-center mb-2'>
                                        <span className="text-sm font-normal text-white rounded-md p-1" style={{ fontSize: '12px', background: 'black', paddingLeft: '10px', paddingRight: '10px' }}>
                                            {prep.rx_number}
                                        </span>
                                    </div>

                                    <p className="text-sm font-medium text-gray-800 mb-1">
                                        {prep.dose ? `[${prep.dose}] ` : ''}{prep.drug}
                                    </p>
                                    <p className="text-xs text-gray-600 mb-2 break-all">
                                        {prep.rxsig}
                                    </p>
                                    <div className="text-xs text-gray-600">
                                        <p>Prepared for: {prep.prepdate}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default EmergenciesTab;





// import React, { useEffect, useState } from 'react';

// import * as Hooks from '../../hooks';
// import { useAuthSelector } from '../../services/selectors/authSelector';
// import { useAllSelector } from '../../services/selectors/allSelector';
// import { clearData, missedRx3x4xRemovingPageNumber, fetchEmergencyPreparedRx } from '../../services/slices/dispense/missedRx3x4x';
// import { ErrorMessages } from '../../components/error/errorMessages';
// import * as Loading from '../../components/common/loader';

// const EmergenciesTab = () => {

//     const dispatch = Hooks.useCustomDispatch();
//     const { pharmacyId } = useAuthSelector();
//     const { missedRx3x4xResponse } = useAllSelector();

//     const [loading, setLoading] = useState(false);
//     const [apiCallMade, setApiCallMade] = useState(false);

//     useEffect(() => {
//         if (pharmacyId) {
//             setLoading(true);
//             if (!apiCallMade) {
//                 dispatch(clearData());
//                 dispatch(missedRx3x4xRemovingPageNumber());
//                 dispatch(fetchEmergencyPreparedRx({
//                     pharmacy_id: pharmacyId,
//                     setLoading: setLoading,
//                 }));
//                 setApiCallMade(true);
//             }
//         }
//         return () => { };
//     }, [pharmacyId]);

//     const items = missedRx3x4xResponse?.emergenciesData || [];
//     const isLoading = missedRx3x4xResponse?.emergenciesLoading && loading;
//     const hasError = missedRx3x4xResponse?.emergenciesError !== null;

//     return (
//         <div className="missed-rx-list">
//             {isLoading ? (
//                 <div className='flex justify-center h-96'>
//                     <Loading.LoadingView />
//                 </div>
//             ) : hasError ? (
//                 <div className='flex justify-center pb-4 mb-4'>
//                     <ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
//                 </div>
//             ) : (items.length === 0 && !missedRx3x4xResponse?.emergenciesLoading) ? (
//                 <p className='flex  pb-4 pt-3 h-96 text-gray-500'>No data available.</p>
//             ) : (
//                 items.map((item, index) => (
//                     <div key={(item.patient_id || index)} className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`emergencyCard-${index}`}>
//                         <div className="flex">
//                             <div className="flex items-center gap-2">
//                                 <h2 className="text-lg font-medium uppercase">
//                                     {item.patient_name}
//                                 </h2>
//                             </div>
//                         </div>

//                         <p className="text-xs text-gray-400 my-1 break-all" style={{ fontSize: '10px' }}>
//                             PHN: {item.phn}
//                         </p>

//                         <div className="mt-2 mb-2 break-all">
//                             <div className="p-2 rounded-md" style={{ backgroundColor: '#f8f9fa', border: '1px solid lightgray' }}>
//                                 <div className="">
//                                     <p className="text-sm font-medium text-gray-800 mb-1">
//                                         {item.drug}
//                                     </p>
//                                     <p className="text-xs text-gray-600 mb-2">
//                                         {item.rxsig}
//                                     </p>
//                                     {/* <p className="text-xs text-gray-600">
//                                         DIN: {item.din}
//                                     </p> */}
//                                     <p className="text-xs text-gray-600">
//                                         Prepared at: {item.prepared_at}
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 ))
//             )}
//         </div>
//     );
// };

// export default EmergenciesTab;


